module.exports = __webpack_public_path__ + "img/reference-danialu-bauelemente.120dbae7.jpg";